// BillingComponent.js
import React, { useState } from 'react';
import { Button, Form, FormGroup, TextInput } from '@carbon/react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import amplitude from './../../analytics/amplitude' // ✅ add tracking

const BillingComponent = ({ token, userEmail, onSuccess, onCancel, cardholderName, setCardholderName }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const track = (eventName, props = {}) => {
    try {
      if (amplitude && typeof amplitude.track === 'function') {
        amplitude.track(eventName, { page: 'BillingComponent', flow: 'signup', plan: 'monthly_15_usd', trial_days: 7, ...props })
      }
    } catch {}
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    if (!stripe || !elements) {
      const msg = 'Stripe.js has not loaded yet.'
      setErrorMessage(msg);
      track('Billing Submitted', { status: 'stripe_not_ready' })
      setLoading(false);
      return;
    }

    try {
      track('Billing Submitted', { status: 'started' })

      // 1️⃣ Create a PaymentMethod, including billing_details.name & email
      const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
        billing_details: {
          name: cardholderName,
          email: userEmail
        }
      });
      if (stripeError) {
        track('Subscription Failed', { phase: 'create_payment_method', code: stripeError.code, message: stripeError.message })
        throw stripeError;
      }

      // 2️⃣ Send paymentMethod.id to backend to create the subscription
      const resp = await fetch('/mlapi/basic/billing/create-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          payment_method_id: paymentMethod.id,
          'cardholder_name': cardholderName
        }),
      });
      if (!resp.ok) {
        track('Subscription Failed', { phase: 'backend_create_subscription', status: resp.status })
        throw new Error('Payment failed');
      }

      // Success!
      track('Subscription Created', { price_usd: 15, currency: 'USD', interval: 'month', trial_days: 7 })
      onSuccess();
    } catch (err) {
      setErrorMessage(err.message || 'Payment error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup legendText="Payment Details">
        <TextInput
          id="cardholder-name"
          labelText="Name on Card"
          placeholder="Jane Q. Customer"
          value={cardholderName}
          onChange={e => setCardholderName(e.target.value)}
          required
        />

        <div className="card-element-wrapper" style={{ marginTop: '1rem' }}>
          <CardElement />
        </div>
      </FormGroup>

      {errorMessage && <div className="error-message">{errorMessage}</div>}

      <div className="billing-actions">
        <Button kind="secondary" onClick={() => { track('Billing Cancelled', { reason: 'user_back' }); onCancel(); }}>
          Back
        </Button>
        <Button type="submit" disabled={loading}>
          {loading ? 'Processing…' : 'Complete Signup'}
        </Button>
      </div>
    </Form>
  );
};

export default BillingComponent;
